import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';
import { FacilityService } from 'src/app/admin/servicies/facility.service';
import { SelfSchedulingConfigService } from 'src/app/admin/servicies/self-scheduling-config-service';
import { AdminSettingsService } from 'src/app/admin/servicies/admin-settings.service';
import { SidebarService } from 'src/app/admin/servicies/sidebar.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { HttpStatusCode } from 'src/app/shared/enums';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { DropdownModel } from 'src/app/shared/models/response/settings/drop-down-model';
import { NotificationSubTemplateResponseModel } from 'src/app/shared/models/response/settings/self-scheduling-config-model/notification-subtemplate-response-model';
import { DuplicateConfigDetails, DuplicateParameters, SelfSchedulingConfigDetailsModel, SelfSchedulingConfigModel, SelfSchedulingGeneralSetupModel, SelfSchedulingWrapper } from 'src/app/shared/models/response/settings/self-scheduling-config-model';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { PreviewTemplateComponent } from '../preview-template/preview-template.component';

@Component({
  selector: 'app-create-configuration',
  templateUrl: './create-configuration.component.html',
  styleUrls: ['./create-configuration.component.sass'],
  standalone: false
})
export class CreateConfigurationComponent extends BaseComponent implements OnInit {
  // @Input() totalCustomeConfig: number = 0;
  loggedInUserId: number;
  branchOptions: DropdownModel[] = [];
  classificationOptions: DropdownModel[] = [];
  insuranceOptions: DropdownModel[] = [];
  subTemplateOptions: DropdownModel[] = [];
  parameterForm: UntypedFormGroup;
  showDuplicateSelectionPopup = false;
  duplicateParameters: DuplicateParameters[] = [];
  configData: SelfSchedulingConfigModel;
  setupData: SelfSchedulingGeneralSetupModel;
  subTemplateList: NotificationSubTemplateResponseModel[] = [];
  selectedTemplate: NotificationSubTemplateResponseModel = new NotificationSubTemplateResponseModel();
  totalCustomeConfig: number;
  showAddAndCreateButton=true;
  constructor(private configService: SelfSchedulingConfigService,
    private webStorageService: WebStorageService,
    private fb: UntypedFormBuilder, private dialogueService: DialogService,
    messageService: MessageService,
    private settingsService: AdminSettingsService,
    private facilityService: FacilityService,
    private sidebarService: SidebarService
  ) {
    super(messageService)

    this.parameterForm = this.fb.group({
      parameter: this.fb.group({
        branch: ['', [Validators.required]],
        classification: ['', [Validators.required]],
        insurance: ['', [Validators.required]]
      }),
      template: this.fb.group({
        templateId: ['', [Validators.required]]
      }),
      selfScheduling: this.fb.group({
        isFreshRemoteTypeAppointment: [null],
        isFreshFacilityTypeAppointment: [null],
        isCancellationAllowed: [null],
        isLimitNoOfCancelAppointments: [null],
        maxCancelAllowed: [null],
        isRescheduleAllowed: [null],
        isLimitNoOfRescheduleAppointments: [null],
        maxRescheduleAllowed: [null],
        isRescheduleRemoteAppointmentType: [null],
        isRescheduleFacilityAppointmentType: [null]
      }),
      general: this.fb.group({
        name: ['', [Validators.required]],
        description: ['', [Validators.required]]
      })
    });

 
  }

  addDynamicValidation() {
    this.parameterForm.get('selfScheduling.isLimitNoOfCancelAppointments')?.valueChanges.subscribe(value => {
      if (value) {
        this.parameterForm.get('selfScheduling.maxCancelAllowed')?.setValidators([Validators.required]);
      } else {
        this.parameterForm.get('selfScheduling.maxCancelAllowed')?.clearValidators();
      }
      this.parameterForm.get('selfScheduling.maxCancelAllowed')?.updateValueAndValidity();
    });

    this.parameterForm.get('selfScheduling.isLimitNoOfRescheduleAppointments')?.valueChanges.subscribe(value => {
      if (value) {
        this.parameterForm.get('selfScheduling.maxRescheduleAllowed')?.setValidators([Validators.required]);
      } else {
        this.parameterForm.get('selfScheduling.maxRescheduleAllowed')?.clearValidators();
      }
      this.parameterForm.get('selfScheduling.maxRescheduleAllowed')?.updateValueAndValidity();
    });
  }

  ngOnInit(): void {
    const loggedInUser = this.webStorageService.getCurrentUserToken();
    this.loggedInUserId = loggedInUser.userId;
    this.loadData(() => {
      if (this.configData) {
        this.setFormValues(this.configData);
        if(this.configData?.id>0)
          {
            this.showAddAndCreateButton=false;
          }
      }
    });
    this.addDynamicValidation();
    this.sidebarService.sidebarData().subscribe((data: SelfSchedulingWrapper) => {
      if(data !=null){
        this.configData = data.configs[0];
        this.setupData = data.setup;
        this.totalCustomeConfig = data.totalCustomeConfig;
      }
    });

  }


  setFormValues(config: SelfSchedulingConfigModel) {
    if (!config) return;

    this.parameterForm.patchValue({
      general: {
        name: config.name || '',
        description: config.description || ''
      },
      selfScheduling: { ...config.jsonValue },
    });
    this.setDropdownDefaultValues(config);
    this.selectedTemplate = this.selectedTemplate = this.subTemplateList.find(x => x.id == config.jsonValue.templateId);
  }

  setDropdownDefaultValues(config: SelfSchedulingConfigModel) {
    if (!config?.jsonValue) return;

    const getSelectedValues = (options: DropdownModel[], ids: string) => {
      return options.filter(option => ids?.split(',').includes(option.value.toString())).map(option => option.value);
    };

    const getInsuranceSelectedValues = (options: DropdownModel[], ids: string) => {
      return options.filter(option => ids?.split(',').includes(option.name.toString())).map(option => option.name);
    };


    this.parameterForm.patchValue({
      parameter: {
        classification: getSelectedValues(this.classificationOptions, config.jsonValue.classificationIds),
        branch: getSelectedValues(this.branchOptions, config.jsonValue.branchIds),
        insurance: getInsuranceSelectedValues(this.insuranceOptions, config.jsonValue.insuranceIds)
      },
      template: {
        templateId: config?.jsonValue?.templateId
      }
    });
  }

  loadData(callback?: () => void) {
    this.loading = true;
    const classificationType$ = this.settingsService.GetClassificationTypes();
    const branchList$ = this.settingsService.GetBranchList();
    const subTemplateList$ = this.configService.GetAllSubTemplate();
    const insuranceList$ = this.configService.GetAllInsurance();


    forkJoin([classificationType$, branchList$, insuranceList$, subTemplateList$]).subscribe(
      (results) => {
        const [classificationTypeResult, branchListResult, insuranceList, subTemplateList] = results;

        this.processResult<any>(classificationTypeResult, () => {
          this.classificationOptions = classificationTypeResult.responseModel.map(item => ({
            value: item.crmClassificationTypeId,
            name: item.crmClassificationDisplayName
          }));
        });

        this.processResult<any>(branchListResult, () => {
          this.branchOptions = branchListResult.responseModel.map(item => ({
            value: item.crmBranchId,
            name: item.crmBranchName
          }));
        });

        this.processResult<any>(insuranceList, () => {
          this.insuranceOptions = insuranceList.responseModel.map(item => ({
            value: item.crmInsurancePatientId,
            name: item.insuranceProviderName
          }));
        });

        this.processResult<any>(subTemplateList, () => {
          this.subTemplateOptions = subTemplateList.responseModel.map(item => ({
            value: item.id,
            name: item.appNotificationEventName
          }));

          subTemplateList.responseModel.forEach(item => {
            this.subTemplateList.push(item);
          });
        });

        this.loading = false;

        if (callback) {
          callback();
        }
      },
      (error) => {
        console.error('Error loading data', error);
        this.loading = false;
      }
    );
  }


  onSaveConfig(isCreateAndAdd=false) {
    console.log(this.parameterForm);
    if (!this.parameterForm.valid) return;
    this.loading = true;
    const { selfScheduling } = this.parameterForm?.value;
    const { branch, classification, insurance } = this.parameterForm?.value?.parameter || {};
    const { general } = this.parameterForm?.value;

    const configObj: SelfSchedulingConfigDetailsModel = {
      ...selfScheduling,
      branchIds: branch?.join(',') || '',
      classificationIds: classification?.join(',') || '',
      insuranceIds: insurance?.join(',') || '',
      ...this.parameterForm?.value?.template
    };

    const config: SelfSchedulingConfigModel = {
      ...general,
      id: this.configData?.id,
      isDefault: false,
      jsonValue: configObj
    };

    const model: SelfSchedulingWrapper = {
      modifiedByUserInfoId: this.loggedInUserId,
      setup: this.setupData,
      configs: [config],
      totalCustomeConfig: this.totalCustomeConfig
    };

  
    this.configService.save(model).subscribe(response => {
      this.loading = false;
      if (!response.isSuccess && response.statusCode === HttpStatusCode.BadRequest) {
        if (this.hasResponseModel(response)) {
          this.showDuplicateSelectionPopup = true;
          this.getNameFromIds(response.responseModel as DuplicateConfigDetails[]);
        }
        else
        {
        this.showErrorMessage("Configuration name already exists.");
        }

      }
      else {
        this.showSuccessMessage('Config saved successfully');
        if(!isCreateAndAdd)
        {
          this.sidebarService.close();
        }
        else
        {
          this.parameterForm.reset();
        }
      }
    }, () => {
      this.loading = false;
      this.showErrorMessage("Error occured while saving config");
    });
  }

  hasResponseModel(response: any): response is ResultOfT<DuplicateConfigDetails[]> {
    return response && "responseModel" in response  && typeof response.responseModel === "object" && Array.isArray(response.responseModel);
  }

  getNameFromIds(duplicateConfigList) {
    if (duplicateConfigList?.length > 0) {
      duplicateConfigList.forEach(config => {
        const branchValues = config.overlappingBranchIds
          .map(id => this.branchOptions.find(branch => branch.value.toString() === id)?.name)
          .filter(name => name)
          .join(",");
        const classificationValues = config.overlappingClassificationIds
          .map(id => this.classificationOptions.find(clasification => clasification.value.toString() === id)?.name)
          .filter(name => name)
          .join(",");
        const insuranceValues = config.overlappingInsuranceIds
          .map(id => this.insuranceOptions.find(insurance => insurance.value.toString() === id)?.name)
          .filter(name => name)
          .join(",");

        if (config.overlappingBranchIds.length > 0) {
          this.duplicateParameters.push({ type: "Branch", values: branchValues });
        }
        if (config.overlappingClassificationIds.length > 0) {
          this.duplicateParameters.push({ type: "Classification", values: classificationValues });
        }
        if (config.overlappingInsuranceIds.length > 0) {
          this.duplicateParameters.push({ type: "Insurance", values: insuranceValues });
        }
      });
    }
  }

  removeDuplicateSelection() {
    if (!this.duplicateParameters.length) return;

    let updatedBranch = [...this.parameterForm.get('parameter.branch')?.value || []];
    let updatedClassification = [...this.parameterForm.get('parameter.classification')?.value || []];
    let updatedInsurance = [...this.parameterForm.get('parameter.insurance')?.value || []];

    this.duplicateParameters.forEach(duplicate => {
      if (duplicate.type === "Branch") {
        updatedBranch = updatedBranch.filter(value =>
          !this.branchOptions.some(option => option.value === value && duplicate.values.includes(option.name))
        );
      }
      if (duplicate.type === "Classification") {
        updatedClassification = updatedClassification.filter(value =>
          !this.classificationOptions.some(option => option.value === value && duplicate.values.includes(option.name))
        );
      }
      if (duplicate.type === "Insurance") {
        updatedInsurance = updatedInsurance.filter(value =>
          !this.insuranceOptions.some(option => option.value === value && duplicate.values.includes(option.name))
        );
      }
    });

    this.parameterForm.patchValue({
      parameter: {
        branch: updatedBranch,
        classification: updatedClassification,
        insurance: updatedInsurance
      }
    });

    this.duplicateParameters = [];
    this.showDuplicateSelectionPopup = false;
    this.onSaveConfig();
  }

  cancelDiscard() {
    this.showDuplicateSelectionPopup = false;
  }

  resetForm() {
    this.parameterForm.reset();
  }

  onChangeTemplate(event: any) {
    this.selectedTemplate = this.subTemplateList.find(x => x.id == event.value);
  }

  EmailPreviewClick() {
    this.dialogueService
      .open(PreviewTemplateComponent, {
        showHeader: true,
        closable: true,
        data: { roleId: 0, type: 'AppointmentInvitation', templateType: 'Email', subTemplate: this.selectedTemplate }
      })
  }

  SMSPreviewClick() {
    this.dialogueService
      .open(PreviewTemplateComponent, {
        showHeader: true,
        closable: true,
        data: { roleId: 0, type: 'AppointmentInvitation', templateType: 'SMS', subTemplate: this.selectedTemplate }
      });
  }

}
